<section class="align-items-md-center d-flex main-section-home-2">
    <div class="container-fluid no-padding">
        <div
            class="swiper-container swiper-nav-bullets swiper-main-section-home equal-height-group swiper-container-initialized swiper-container-horizontal">
            <swiper [config]="swiperConfig">

                <ng-template swiperSlide class="equal-height swiper-slide swiper-slide-custom-1 text-left">
                    <div class="row">
                        <div class="col-12 col-lg-7 col-md-10 col-xl-6">
                            <header>
                                <h1 class="main-title">¡Potencia tu carrera docente con ProfeJOBS!</h1>
                                <p class="slide-cta-text">Accede a la mayor red de ofertas laborales permanentes y de reemplazo en Chile</p>
                                <div><a class="btn btn-block btn-cta btn-primary mgn-bottom-4 mgn-rigth-12 rounded-lg"
                                        [routerLink]="[constantsService.BASE_PATH_EMPLOYEE_BASIC]" target="_self"
                                        title="Regístrate como profesor">
                                        <div class="align-items-center d-flex justify-content-center">
                                            <div class="padding-right-15"><span
                                                    class="font-weight-normal">Regístrate</span><br />como profesor
                                            </div>
                                            <div><i class="pj-ico pj-ico-arrow-next"></i>
                                            </div>
                                        </div>
                                    </a><a class="btn btn-cta btn-primary mgn-bottom-4 rounded-lg"
                                        [routerLink]="[constantsService.BASE_PATH_EMPLOYER]" target="_self"
                                        title="Regístrate como institución">
                                        <div class="align-items-center d-flex justify-content-center">
                                            <div class="padding-right-15"><span
                                                    class="font-weight-normal">Regístrate</span><br />como
                                                institución
                                            </div>
                                            <div><i class="pj-ico pj-ico-arrow-next"></i>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </header>
                        </div>
                    </div>
                </ng-template>

            </swiper>
            <div id="swiper-pagination-home-header" class="swiper-pagination"></div>
            <div class="controls-swiper-wrapper-2">
                <div id="swiper-pagination-home-header-prev" class="swiper-button-prev swiper-card-prev"></div>
                <div id="swiper-pagination-home-header-next" class="swiper-button-next swiper-card-next"></div>
            </div>
        </div>
    </div>
</section>